module.exports = __webpack_public_path__ + "bd42e5d8d8964bc2bcb311d8ea1c551c.svg";